<template>
  <div>
    <el-table :data="data" border height="100%" style="width: 100%">
      <el-table-column prop="frequency" label="频率" :width="70">
      </el-table-column>
      <el-table-column prop="upload_time" label="上传时间" :width="160">
      </el-table-column>
      <el-table-column label="录音文件" :width="100">
        <template slot-scope="scope">
          <el-button v-if="scope.row.radio_file_path" type="text" @click="$playAudio(scope.row.radio_file_path,scope.row.frequency,scope.row.upload_time)">点击播放</el-button>
          <template v-else>无文件</template>
        </template>
      </el-table-column>
      <el-table-column prop="recognition" label="音频识别">
      </el-table-column>
      <el-table-column prop="result_type" label="判别结果" :width="85">
      </el-table-column>
    </el-table>
    <Pagination totalCountOrURL="/terminal/cnt_audioRd" :params="{device_lgid:lgid}" @change="handlePageChange"></Pagination>
  </div>
</template>

<script>
  import Pagination from "@/components/PageNations/Pagination";
  export default {
    props: ["lgid"],
    components: {
      Pagination
    },
    mounted() {
      this.getData();
    },
    watch: {
      lgid() {
        this.getData();
      }
    },
    data() {
      return {
        data: [],
        page: 1,
        size: 10
      };
    },
    methods: {
      handlePageChange(params) {
        this.page = params.page;
        this.size = params.size;
        this.getData();
      },
      getData() {
        if (this.lgid) {
          this.$getJSON("/terminal/s_audioRd", {
            device_lgid: this.lgid,
            page: this.page,
            size: this.size
          }).then(res => {
            this.data = res.data;
          });
        }
      }
    }
  };

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Tables/AudioRd.vue